import { render, staticRenderFns } from "./ConstructorElement.vue?vue&type=template&id=3b997690"
import script from "./ConstructorElement.vue?vue&type=script&lang=js"
export * from "./ConstructorElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports